import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Entete } from '../../composants/mise-en-page.tsx';
import { FormulaireProduit } from './FormulaireProduit.tsx';

/**
 * Création d'un produit — page à part, RG-019 à RG-029.
 *
 * Le formulaire vivait empilé AU-DESSUS de la liste, sur `/produits` : avec
 * quatre sections (identité, prix, stock, images), il poussait la liste loin
 * en bas et les deux se marchaient dessus au moindre écran modeste. Une
 * création est un geste ponctuel, elle mérite son propre espace — la liste,
 * elle, reste ce qu'on consulte tout le temps.
 */
export function NouveauProduit(): ReactNode {
  const navigate = useNavigate();

  return (
    <>
      <Entete
        titre="Nouveau produit"
        actions={<Link to="/produits">← Retour aux produits</Link>}
      />
      <FormulaireProduit
        onCree={(avertissements) => {
          // Les avertissements ne se lisent qu'une fois REVENU sur la liste :
          // ce composant se démonte à la navigation, et un message affiché
          // ici disparaîtrait avec lui.
          void navigate('/produits', { state: { avertissements } });
        }}
      />
    </>
  );
}
